import InvalidArgumentError from "@/errors/InvalidArgumentError";

export async function validateFormOnSubmit(companyName, companyPDF) {
  const reasons = [];

  const nameIssue = validateCompanyName(companyName);
  if (nameIssue) reasons.push(nameIssue);

  const pdfIssue = validatePDF(companyPDF);
  if (pdfIssue) reasons.push(pdfIssue);

  if (reasons.length === 0) return;

  const message = reasons.join(", and ");
  throw new InvalidArgumentError(message);
}

function validateCompanyName(name) {
  if (!(typeof name === "string" || name instanceof String)) {
    return "The company name must be a string";
  }
  if (name.trim() === "") {
    return "Please enter the company name";
  }
}

function validatePDF(file) {
  if (!file) return "Please upload a PDF file.";
  if (file.size === 0) return "The selected PDF is empty. Please choose another file.";
  if (file.type !== "application/pdf") return "The statement must be uploaded as a PDF file.";
}
